<template>
  <div class="login_bg_ page_">
    <topBar />
    <div class="w1000_">
      <div class="left_wrap_">
        <img src="@/assets/wxmall/2.png"/>
        <div>欢迎登录光大商城</div>
      </div>
      <div class="login_container_">
        <div class="login_title_">
          <ul class="tabs_">
            <li @click="switchTab(0)" :class="activeTab == 0 ? 'active_' : ''">
              登录
            </li>
            <li style="display:none;" @click="switchTab(1)" :class="activeTab == 1 ? 'active_' : ''">
              忘记密码
            </li>
          </ul>
        </div>
        <a-form
          v-if="activeTab == 1"
          class="login_form_ pwd_form_"
          :form="pwdForm"
          @submit="handleChangePwdSubmit"
        >
          <a-form-item class="mrg_b16_">
            <a-input
              v-decorator="[
                'loginName',
                {
                  rules: [{ required: true, message: '请输入用户名/手机号!' }]
                }
              ]"
              placeholder="请输入用户名"
              size="large"
            >
            </a-input>
          </a-form-item>
          <a-form-item class="mrg_b16_">
            <a-input
              type="password"
              v-decorator="[
                'passWord',
                {
                  rules: [
                    { required: true, message: '请设置新密码' },
                    { validator: validateToNextPassword }
                  ]
                }
              ]"
              placeholder="请设置新密码"
              size="large"
              @blur="handleConfirmBlur"
            >
            </a-input>
          </a-form-item>
          <a-form-item class="mrg_b16_">
            <a-input
              type="password"
              v-decorator="[
                'confirmPwd',
                {
                  rules: [
                    { required: true, message: '请确认新密码' },
                    { validator: compareToFirstPassword }
                  ]
                }
              ]"
              placeholder="请确认新密码"
              size="large"
            >
            </a-input>
          </a-form-item>
          <a-form-item style="margin-bottom: 6px;">
            <sendCode v-model="smsCode" size="large" field="verifyCode" :form="pwdForm"/>
          </a-form-item>
          <div :class="`error_ ${hasError ? 'show_' : 'hide_'}`">
            {{ errorMsg }}
          </div>
          <a-form-item>
            <a-button
              size="large"
              type="primary"
              html-type="submit"
              :disabled="submitDisabled"
              class="login-form-button"
            >
              确认修改
            </a-button>
          </a-form-item>
        </a-form>
        <a-form
          v-else
          id="components-form-demo-normal-login"
          :form="form"
          class="login_form_"
          @submit="handleSubmit"
        >
          <a-form-item>
            <a-input
              v-decorator="[
                'userName',
                {
                  rules: [{ required: true, message: '请输入用户名!' }]
                }
              ]"
              placeholder="请输入用户名"
              size="large"
            >
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
                'password',
                {
                  rules: [{ required: true, message: '请输入密码' }]
                }
              ]"
              type="password"
              placeholder="请输入密码"
              size="large"
            >
            </a-input>
          </a-form-item>
          <!-- <a-form-item style="margin-bottom: 0;display: none;">
            <a-input
              key="vericode"
              class="vericode_"
              v-decorator="[
                'verifyCode',
                {
                  rules: [{ required: true, message: '请输入验证码' }]
                }
              ]"
              placeholder="请输入验证码"
              size="large"
            >
            </a-input>
            <img
              class="veri_code_"
              @click="changeImgCodeUri"
              :src="imgCodeUri"
            />
          </a-form-item> -->
          <div :class="`error_ ${hasError ? 'show_' : 'hide_'}`">
            {{ errorMsg }}
          </div>
          <div style="display: none;" class="hint_ clearfix_">
            <router-link class="f_r_" :to="{name: 'register'}">还没账户？去注册</router-link>
          </div>
          <a-form-item>
            <a-button
              size="large"
              type="primary"
              html-type="submit"
              class="login-form-button"
            >
              立即登录
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <div class="footer_">
        <div class="w1000_ b_border_">
        </div>
        <div>光大保险商城</div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
import sendCode from '../wxmall/components/sendCode'
import { setLogined, setToken,cacheUserInfo,getUserInfo} from "@/utils/authorized";
import topBar from './components/topBar'
const imgCodeUri = `/api_mall/diccApi/verifycode/img?rand=`

export default {
  data() {
    return {
      errorMsg: "",
      hasError: false,
      pwdForm: this.$form.createForm(this),
      activeTab: 0,
      imgCodeUri: imgCodeUri + Math.random(),
      submitDisabled: false,
      smsCode: ''
    };
  },
  components: {
    topBar,
    sendCode
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  mounted(){
  },
  methods: {
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.pwdForm;
      console.log('compareToFirstPassword -> ', form)
      if (value && value !== form.getFieldValue('passWord')) {
        callback('两个密码不一致!');
      } else {
        callback();
      }
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.pwdForm;
      if (value && this.confirmDirty) {
        form.validateFields(['confirmPwd'], { force: true });
      }
      callback();
    },
    handleChangePwdSubmit(e) {
      e && e.preventDefault();
      this.submitDisabled = false;
      this.pwdForm.validateFields((error, values) => {
        if (!error) {
          console.log("handleChangePwdSubmit -> ", values);
          api.findPwd({
            ...values,
            verifyCode: this.smsCode
          }).then(res => res.data).then(data => {
            this.hasError = false
            this.activeTab = 1
            this.$message.success('密码修改成功')
          }).catch(err => {
            this.errorMsg = err.data.msg || "";
            this.hasError = true;
            this.submitDisabled = false
          })
        }
      });
    },
    switchTab(val) {
      this.activeTab = val;
      this.hasError = false
    },
    changeImgCodeUri() {
      this.imgCodeUri = imgCodeUri + Math.random();
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          // setLogined(1);
          // this.$router.push("/dashboard");
          api
            .gdLogin({
              ...values
            })
            .then(res => res.data)
            .then(data => {
              if(data.returnCode =='00'){
                this.hasError = false;
                setLogined(1);
                setToken('')
                let locdata={
                  userName:values.userName
                }
                cacheUserInfo(locdata)
                this.isLogined=true
                this.$router.push({
                  name: 'gd-home'
                });
              }else{
                this.$message.error(data.returnMsg)
              }
              
              // location.reload()
            })
            .catch(error => {
              console.log("handleSubmit error -> ", error);
              if (error.data.code == '205') {
                this.changeImgCodeUri()
              }
              this.errorMsg = error.data.msg || "";
              this.hasError = true;
            });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.page_ {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .vericode_ {
        width: 179px;
    }
    .mrg_b16_ {
        margin-bottom: 16px;
    }
    .hint_ {
        margin: 0 0 25px;
    }
}
.footer_ {
    font-size: 12px;
    color: #666;
    line-height: 141px;
    text-align: center;
}
.b_border_ {
    border-bottom: 1px solid rgba(1, 1, 1, 0.2);
}
.error_ {
  color: red;
  line-height: 24px;
  height: 24px;
  &.hide_ {
    visibility: hidden;
  }
  &.show_ {
    visibility: show;
  }
}
.login_bg_ {
  height: 100%;
  overflow: hidden;
  background: #fff;

  .left_wrap_ {
    display: inline-block;
    vertical-align: middle;
    color: #fff;
    width: 467px;
    margin-right: 143px;
    text-align: center;
    color: #333;
    & > img {
        width: 467px;
        height: auto;
    }
    .list_ {
      li {
        &::before {
          content: "";
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-right: 8px;
          background: #fff;
          vertical-align: middle;
        }
      }
    }
    .line_ {
      width: 36px;
      height: 3px;
      background: rgba(255, 255, 255, 1);
    }
    .title_ {
      font-size: 26px;
      margin: 28px 0;
    }
    .copyright_ {
      margin: 29px 0 19px;
    }
    .fs9_ {
      font-size: 9px;
    }
  }
}
.login_container_ {
  display: inline-block;
  vertical-align: middle;
  width: 362px;
  height: 400px;
  padding: 31px 42px 0;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0px 5px 20px 0px rgba(121, 118, 118, 0.3);
  * {
    box-sizing: border-box;
  }
  .login_title_ {
    margin-bottom: 29px;
    height: 27px;
    cursor: pointer;

    li {
      display: inline-block;
      color: #999999;
      font-size: 12px;
      transition: all 0.3s ease-in;
      margin-right: 29px;
      &.active_ {
        font-size: 18px;
        color: #FF4C1C;
        font-weight: 600;
      }
    }
  }
  .veri_code_ {
    display: inline-block;
    vertical-align: top;
    width: 91px;
    height: 40px;
    background: rgba(239, 242, 255, 1);
    margin-left: 8px;
  }
  .steps_wrap_ {
    font-size: 9px;
    color: #666666;
    text-align: center;
    margin: 26px 0 42px;

    li {
      display: inline-block;
      vertical-align: middle;
    }
    .desc_01_ {
      width: 96px;
    }
    .desc_02_ {
      width: 66px;
    }
    .step_ {
      display: block;
      width: 16px;
      height: 16px;
      margin: 0 auto;
      border-radius: 50%;
      line-height: 16px;
      background: #23e2b7;
      color: #fff;
      text-align: center;
      margin-bottom: 7px;
    }
    .arrow_ {
      display: inline-block;
      vertical-align: middle;
      width: 40px;
      height: 21px;
    //   background: url("../assets/arrow.png") no-repeat;
      background-size: 100% auto;
      margin: 0 28px 0 23px;
    }
  }
}
.login_form_ .login-form-button {
  width: 100%;
  margin: 0 auto;
  background: rgba(255,76,28,1);
  border-radius: 3px;
  border: none;
  color: #fff !important;
  &:hover {
    background: rgba(255,76,28,0.8);
  }
  &:focus {
    background: rgba(255,76,28,1);
  }
  &:active {
    color: #fff;
  }
}
</style>
